module.exports = __webpack_public_path__ + "media/images/icons/flags/AF-ac2a6826883432d3c4cf7d83cbd26fe6.svg";